export class DocumentEditOperation {
  public firstClickDateTime: Date;
}
